import { FC, ReactNode, cloneElement, isValidElement } from "react"
import { Button, Modal, Stack, Text, useModalsStack } from "@mantine/core"
import { ContactForm } from "../ContactForm"
import classes from "./styles.module.scss"
import { IFormData } from "@/shared/types/formData"

interface ContactModalProps {
	object?: string
	subject?: string
	children: ReactNode
	title?: string
	subtitle?: string
	onSubmit?: (data: IFormData) => void
}

export const ContactModal: FC<ContactModalProps> = ({
	children,
	title,
	subtitle,
	onSubmit,
	object,
	subject,
}) => {
	const stack = useModalsStack(["contact-modal", "thanks-modal"])

	const handleSubmit = (data: IFormData) => {
		onSubmit?.(data)
		stack.open("thanks-modal")
	}

	const triggerElement = isValidElement(children)
		? cloneElement(children as any, {
				...children.props,
				onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
					event.preventDefault()
					stack.open("contact-modal")
				},
		  })
		: null

	return (
		<>
			<Modal.Stack>
				<Modal
					{...stack.register("contact-modal")}
					onClose={stack.closeAll}
					centered
					size="md"
					padding={0}
					radius={12}
					className={classes.modal}
					classNames={{ content: classes.content, header: classes.header, close: classes.close }}
					styles={{
						content: {
							backgroundColor: "#000",
						},
						header: {
							backgroundColor: "#000",
						},
					}}
				>
					<ContactForm
						title={title}
						subtitle={subtitle}
						onSubmit={handleSubmit}
						object={object}
						subject={subject}
						bg="transparent"
						extraClasses={[classes.form]}
					/>
				</Modal>
				<Modal
					{...stack.register("thanks-modal")}
					onClose={stack.closeAll}
					centered
					size="md"
					radius={12}
					styles={{
						body: {
							paddingBottom: "32px",
						},
					}}
					className={classes.modal}
				>
					<Stack gap={12} align="center">
						<Text size="lg" fw="weight-600" ta="center">
							Спасибо за ваше обращение!
						</Text>
						<Text size="sm" fw="weight-400" ta="center">
							Наш менеджер свяжется с вами в ближайшее время.
						</Text>
						<Button py={0} onClick={stack.closeAll} className={classes.button}>
							Закрыть
						</Button>
					</Stack>
				</Modal>
			</Modal.Stack>

			{triggerElement}
		</>
	)
}
